module.exports = __webpack_public_path__ + "01b9e9878e80576dc4da6cc07424f946.svg";